import { render, staticRenderFns } from "./BoldButton.vue?vue&type=template&id=3f72d42c&"
import script from "./BoldButton.vue?vue&type=script&lang=js&"
export * from "./BoldButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports